import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { PasswordInput } from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Contraseña actualizada. Ya puedes ingresar.");
      navigate("/login");
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-4">
      <Card className="w-full max-w-md p-6">
        <form onSubmit={submit}>
          <h1 className="text-xl font-bold">Nueva contraseña</h1>
          <p className="text-muted-foreground text-sm mt-1 mb-4">Elige una contraseña segura.</p>
          <Label htmlFor="password">Contraseña nueva</Label>
          <PasswordInput id="password" value={password} onChange={(e) => setPassword(e.target.value)}
            required minLength={6} wrapperClassName="mb-4" data-testid="reset-password" />
          <Button type="submit" className="w-full" disabled={loading || !token} data-testid="reset-submit">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Actualizar contraseña"}
          </Button>
          <Link to="/login"><Button variant="ghost" className="w-full mt-2">Volver a ingresar</Button></Link>
        </form>
      </Card>
    </div>
  );
}
